module.exports = __webpack_public_path__ + "static/img/data2-list2.0bb58977.png";